/* Cars4Part menu drawer: opened by any [aria-controls="sidebar-menu"] button. */
(() => {
  if (window.customElements.get('c4p-menu-drawer')) return;

  class C4pMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.c4p-menu__panel');
      this.abort = new AbortController();
      const signal = this.abort.signal;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(`[aria-controls="${this.id}"]`);
        if (!trigger || this.contains(trigger)) return;
        event.preventDefault();
        this.isOpen ? this.close() : this.open(trigger);
      }, { signal });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-c4p-menu-close]')) {
          this.close();
          return;
        }

        const summary = event.target.closest('[data-c4p-accordion] > summary');
        if (summary) {
          event.preventDefault();
          this.toggleAccordion(summary.parentElement);
        }
      }, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      }, { signal });
    }

    disconnectedCallback() {
      this.abort?.abort();
      document.documentElement.classList.remove('c4p-menu-locked');
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open(trigger) {
      this.lastFocus = trigger || document.activeElement;
      this.setAttribute('aria-hidden', 'false');
      void this.offsetWidth;
      this.classList.add('is-open');
      document.documentElement.classList.add('c4p-menu-locked');
      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((el) => el.setAttribute('aria-expanded', 'true'));
      setTimeout(() => this.panel.focus({ preventScroll: true }), 60);
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('c4p-menu-locked');
      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((el) => el.setAttribute('aria-expanded', 'false'));
      this.lastFocus?.focus?.({ preventScroll: true });
    }

    /* Smooth height animation for the dropdown headings and the region list */
    toggleAccordion(details) {
      const content = details.querySelector(':scope > .c4p-menu__panel-content');
      if (!content || !content.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.open = !details.open;
        return;
      }

      details.c4pAnimation?.cancel();

      if (details.open) {
        const animation = content.animate(
          { height: [`${content.offsetHeight}px`, '0px'], opacity: [1, 0] },
          { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        details.c4pAnimation = animation;
        animation.onfinish = () => {
          details.open = false;
          details.c4pAnimation = null;
        };
      } else {
        details.open = true;
        const animation = content.animate(
          { height: ['0px', `${content.offsetHeight}px`], opacity: [0, 1] },
          { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        details.c4pAnimation = animation;
        animation.onfinish = () => {
          details.c4pAnimation = null;
        };
      }
    }

    trapFocus(event) {
      const focusables = Array.from(this.panel.querySelectorAll('a[href], button, select, input, summary')).filter((el) => el.offsetParent !== null);
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  window.customElements.define('c4p-menu-drawer', C4pMenuDrawer);
})();
